import React from "react";
// @mui/icons-material
// import  from "@mui/icons-material/";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import Muted from "components/Typography/Muted.js";
import Link from "next/link";

import data_initial from "data/linksData3.js"; // Adjust the path accordingly

import Tables from "pages-sections/glossary/glossaryTableDev.js";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuBookIcon from "@mui/icons-material/MenuBook"; // Import the book icon

import styles from "./GlossarySections.module.scss";

const renderLinks = (start, end, main_section, sub_section, this_page) => {
  // Filter and slice the links here
  const linksArray =
    //data_initial[tag]?.links.filter(
    data_initial[main_section][sub_section]?.links.filter(
      (link) => link.name !== this_page
    ) || [];

  return (
    <List>
      {" "}
      {/* Remove default list styling */}
      {linksArray.slice(start, end).map((link) => (
        <ListItem key={link.id}>
          <ListItemIcon style={{ marginRight: "-20px" }}>
            <ArrowForwardIosIcon fontSize="small" />
          </ListItemIcon>
          <Link href={link.href}>{link.name}</Link>
        </ListItem>
      ))}
    </List>
  );
};

const renderBreadcrumb = (main_section, sub_section, this_page, classes) => {
  const breadcrumbs = data_initial[main_section][sub_section].breadcrumb.map(
    (item, index) => (
      <React.Fragment key={index}>
        <Link
          href={item.href}
          style={{
            color: "#9c27b0",
            textDecoration: "none",
            backgroundColor: "transparent",
            "&:hover, &:focus": {
              color: "#89229b",
              textDecoration: "none",
            },
          }}
        >
          {item.name}
        </Link>
        <span className={classes.separator}>&gt;</span>
      </React.Fragment>
    )
  );

  // Adding the current page as the last item in the breadcrumbs
  breadcrumbs.push(
    <React.Fragment key={"current"}>
      <span>{this_page}</span>
    </React.Fragment>
  );

  return breadcrumbs;
};

export default function SimilarPages({
  main_section,
  sub_section,
  this_page,
  ...rest
}) {
  const classes = styles;
  return (
    <div className="cd-section" {...rest}>
      <div className={classes.container}>
        <div className={classes.section2}>
          <GridContainer
            alignItems="center"
            spacing={8}
            style={{ padding: "0px" }}
          >
            <GridItem xs={12} sm={10} md={10} lg={10}>
              <GridContainer>
                <GridItem xs={12} sm={3} md={3}>
                  <Tables />
                  <Link href="/glossary/web-analytics-glossary">
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "20px",
                        color: "#3c4858",
                        textDecoration: "none",
                        backgroundColor: "transparent",
                        "&:hover, &:focus": {
                          color: "#89229b",
                          textDecoration: "none",
                        },
                      }}
                    >
                      <div style={{ textAlign: "left", paddingLeft: "3rem" }}>
                        <MenuBookIcon
                          style={{ fontSize: "2rem", textAlign: "left" }}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: "0.875rem",
                          paddingBottom: "1rem",
                          textAlign: "left",
                          //paddingLeft: "1rem",
                        }}
                      >
                        {" "}
                        Go to rest of Glossary
                      </div>
                    </div>
                  </Link>
                </GridItem>
                <GridItem xs={12} sm={9} md={9}>
                  <h4>
                    <strong>Related Definitions </strong>
                  </h4>
                  <GridContainer>
                    {[0, 3, 6].map((start, idx) => (
                      <GridItem xs={12} sm={12} md={4} key={idx}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={12}>
                            {renderLinks(
                              start,
                              start + 3,
                              main_section,
                              sub_section,
                              this_page
                            )}
                          </GridItem>
                        </GridContainer>
                      </GridItem>
                    ))}
                  </GridContainer>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={6} sm={3} md={3}></GridItem>
                <GridItem xs={12} sm={9} md={9}>
                  <div className={classes.container}>
                    {renderBreadcrumb(
                      main_section,
                      sub_section,
                      this_page,
                      classes
                    )}
                  </div>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
